import { User, UserData, UserHelper } from "@app/user/model/user";

export class CustomerHelper extends UserHelper {
    dbTypeName = "Customer";
    dbTypeNamePlural = "Customers";
}

export type Customer = User;
export type CustomerData = UserData;
